import type { CollapseProps } from '@chakra-ui/react'
import { Collapse } from '@chakra-ui/react'
import type { Ref} from 'react'
import { useRef } from 'react'

export const CustomCollapse = ({ children, ...props }: CollapseProps) => {
    const ref = useRef<HTMLDivElement>()
    if (ref.current) ref.current.style.overflow = 'visible'

    return (
        <Collapse {...props} ref={ref as Ref<HTMLDivElement>}>
            {children}
        </Collapse>
    )
}